(() => {
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('#PolygonsData')) window.location.reload();
    });
  }
  const button = document.querySelector('[data-preview-offer]');
  const template = document.getElementById('PolygonsOfferPreview');
  if (!button || !template || button.hidden || window.PolygonsNativeCommerce) return;
  const openOffer = () => {
    const content = document.querySelector('[data-modal-content]');
    if (!content) return;
    content.replaceChildren(template.content.cloneNode(true));
    window.PolygonsUI?.open('modal');
    try { sessionStorage.setItem('polygons.offer5.preview.seen', '1'); } catch {}
    requestAnimationFrame(() => content.querySelector('input')?.focus({ preventScroll: true }));
  };
  button.addEventListener('click', openOffer);
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-preview-offer-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!event.target.reportValidity()) return;
    event.target.reset();
    event.target.hidden = true;
    const result = document.querySelector('[data-preview-offer-result]');
    if (result) result.hidden = false;
  }, true);
  let seen = false;
  try { seen = sessionStorage.getItem('polygons.offer5.preview.seen') === '1'; } catch {}
  if (!seen && !window.Shopify?.designMode) setTimeout(() => {
    if (!document.querySelector('[data-sheet].is-open')) openOffer();
  }, 4000);
})();
